import { put, takeEvery } from 'redux-saga/effects'
import { sagaActions } from '../sagas'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

const makeBoardActivitiesChannelData = (boardId) => {
  return function * channelData (action) {
    const { channel } = action.payload

    if (channel === 'activity-board-' + boardId) {
      yield put(sagaActions.requestMarkBoardAsRead({ id: boardId }))
    }
  }
}

export default function * boardActivitiesChannelData (boardId) {
  const channelData = makeBoardActivitiesChannelData(boardId)

  yield takeEvery(CHANNEL_DATA, channelData)
}
